import { Select } from 'antd'
import { useDivisions } from '../../../../../domain/divisions/divisionsQueries'
import { useContext } from 'react'
import { ItemsContext } from '../../../../Items/ItemsRoot'

type Props = {
  divisionId: number | null | undefined
  onChange: (divisionId: number) => void
}

const DivisionSelector = ({ divisionId, onChange }: Props) => {
  const { jobData: { jobType } } = useContext(ItemsContext)

  const divisionsQuery = useDivisions()
  const options = (divisionsQuery.data ?? [])
    .filter(x => x.type === jobType)
    .map(division => ({ value: division.id, label: division.name }))

  return <Select
    value={divisionId}
    options={options}
    popupMatchSelectWidth={false}
    onChange={value => onChange(value)}
    showSearch
    optionFilterProp='label'
  />
}

export default DivisionSelector